export enum UserSettingsTab {
  PROFILE = 'My profile',
  USERS = 'Users',
  INTEGRATIONS = 'Integrations',
  ENVIRONMENTS = 'Environments',
  AGENTIC_ACCESS = 'Agentic access',
  MCP_CONNECTIONS = 'MCP connections',
}
